



































import {mapGetters} from 'vuex';
import Vue, {PropType} from 'vue';
import {TranslateResult} from 'vue-i18n';
import {CategoryAPI} from '#/Category';

interface ExtraNode {
  name: TranslateResult;
  id: number;
  default?: boolean;
  all?: boolean;
}

interface ComponentData {
  openNodes: string[];
  extraNodes: ExtraNode[];
  activeCat: (ExtraNode | CategoryAPI)[];
  lastActive: ExtraNode | CategoryAPI | null;
}

export default Vue.extend({
  name: 'NavSlider',

  props: {
    displayed: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
  },

  data(): ComponentData {
    return {
      openNodes: [],
      extraNodes: [
        {
          name: this.$t('template.navSlider.home'),
          id: -1,
          default: true,
        },
        {
          name: this.$t('template.navSlider.showAll'),
          id: 0,
          all: true,
        },
      ],
      activeCat: [],
      lastActive: null,
    };
  },

  computed: {
    ...mapGetters([
      'categories',
      'typeFilter',
      'categoryFromId',
    ]),
    /**
     * Indique si l'arbe est ouvert pour l'affichage du bouton de fermeture
     *
     * @returns {boolean}
     */
    isOpenTree(): boolean {
      return this.openNodes.length > 0;
    },
    /**
     * Retourne la liste des éléments du treeview
     * le choix "Toutes catégories" est suivi du type d'annonce
     * si un filtre sur le type est activé
     *
     * @returns {Object[]}
     */
    navChoices(): CategoryAPI[] {
      let basicNav = this.extraNodes;
      if (this.typeFilter) {
        const postfix = this.$t(`template.navSlider.typePostfix.${this.typeFilter.display}`) as string;
        basicNav = basicNav.map(choice => ({
          ...choice,
          ...choice.all ? {name: choice.name + postfix} : {},
        }));
      }

      return [
        ...basicNav,
        ...this.categories,
      ];
    },
  },

  created() {
    this.setActiveCatFromQuery();
  },

  watch: {
    $route: {
      deep: true,
      handler: function (): void {
        this.setActiveCatFromQuery();
      },
    },
  },

  methods: {
    /**
     * Restore la catégorie active depuis la route courante
     * et ouvre l'arbre jusqu'à la catégorie active
     */
    setActiveCatFromQuery(): void {
      const activesQuery = Object.keys(this.$route.query);

      this.openNodes = [];

      if (!['DefaultList', 'AdvertList'].includes(this.$route.name as string)
          || activesQuery.includes('author__id') || activesQuery.includes('tag')) {
        this.activeCat = [];
      } else {
        const {category: categoryFilter} = this.$route.query;
        if (categoryFilter) {
          const category = this.categoryFromId(parseInt(categoryFilter as string));
          this.activeCat = [category];
          if (category.parentCategory) {
            const parentCategory = this.categoryFromId(category.parentCategory);
            this.openNodes.push(parentCategory);
            if (parentCategory.parentCategory) {
              this.openNodes.push(this.categoryFromId(parentCategory.parentCategory));
            }
          }
        } else {
          this.activeCat = [this.extraNodes[(this.$route.name as string) === 'DefaultList' ? 0 : 1]];
        }
      }
    },
    onCloseTree() {
      this.openNodes = [];
    },
    /**
     * Navigue vers la catégorie sélectionnée, la page personnalisée ou l'ensemble de
     *
     * @param {Category[]|Object[]} activeCategory
     */
    onActiveCategory(activeCategory: (ExtraNode | CategoryAPI)[]): Promise<void> {
      return new Promise((resolve, reject) => {
        const selectedCategory: ExtraNode | undefined = activeCategory[0];
        if (selectedCategory) {
          // page perso
          if (selectedCategory.id < 0) {
            if (this.$route.name === 'DefaultList') {
              resolve();
            } else {
              this.$router.push({
                name: 'DefaultList',
              })
                  .then(() => {
                    resolve();
                  })
                  .catch(() => {
                    reject();
                  });
            }
          } else {
            const categoryQuery = selectedCategory.id > 0 ? {category: selectedCategory.id} : {};
            // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
            const {category, author__id, tag, q, ...cleanedQuery} = this.$route.query;
            const routerQuery = Object.assign({}, cleanedQuery, categoryQuery);
            this.$router.push({
              name: 'AdvertList',
              query: routerQuery,
            })
                .then(() => {
                  resolve();
                })
                .catch(() => {
                  reject();
                });
          }
        } else {
          // réactive l'élément s'il était déjà actif
          this.setActiveCatFromQuery();
        }
        this.$emit('update:displayed', false);
        resolve();
      });
    },
  },
});
